import { useEffect, useState } from 'react';
import { LoginForm } from '../components/LoginForm';
import logoImage from '../assets/pltx-sync-logo.png';

export default function Index() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Geen cookie check meer - altijd login formulier tonen
    // Dit voorkomt problemen met multi-shop beheer
    setIsChecking(false);
  }, []);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  if (isChecking) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-cyan-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-600 mx-auto mb-4"></div>
          <p className="text-cyan-600">Controleren van login status...</p>
        </div>
      </div>
    );
  }

  if (isLoggedIn) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-cyan-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-green-600 text-6xl mb-4">✓</div>
          <h2 className="text-2xl font-bold text-cyan-600 mb-2">Succesvol ingelogd!</h2>
          <p className="text-gray-600">U wordt doorgestuurd naar de hoofdapplicatie...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 to-blue-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="flex justify-center items-center mb-4">
            <img 
              src={logoImage} 
              alt="PLTX-SYNC Logo" 
              className="w-20 h-20 object-contain"
            />
          </div>
          <div className="text-2xl font-bold text-cyan-600 mb-1">PLTX-SYNC</div>
        </div>
        
        {/* Login Form */}
        <LoginForm onLoginSuccess={handleLoginSuccess} />
      </div>
    </div>
  );
}
